import io from 'socket.io-client';

/**
 * Crea una nueva instancia de socket con autenticación
 */
export function createSocket(userId: string, apiUrl: string = process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:3000') {
  return io(apiUrl, {
    auth: {
      userId: userId,
    },
    transports: ['websocket', 'polling'], // Asegurar compatibilidad
    upgrade: true,
    rememberUpgrade: true,
    path: '/socket.io/'
  });
}

/**
 * Tipo de socket para usar en componentes
 */
export type SocketType = ReturnType<typeof createSocket>;
